// extracted by mini-css-extract-plugin
export default {"list":"org_detail_fishing_reports_list__list--fxeA","frRows":"org_detail_fishing_reports_list__frRows--t4PF","card":"org_detail_fishing_reports_list__card--mB3K"};